import { render, staticRenderFns } from "./display-field-badge-link.vue?vue&type=template&id=3680fa9e&scoped=true&"
import script from "./display-field-badge-link.ts?vue&type=script&lang=ts&"
export * from "./display-field-badge-link.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-badge-link.scss?vue&type=style&index=0&id=3680fa9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3680fa9e",
  null
  
)

export default component.exports